module.exports = __webpack_public_path__ + "media/images/lb/709-dbde88d602946c518829f1f87b2e5893.svg";